import type { IconSvgObject } from './types';

const ArrowBigLeftDashIcon: IconSvgObject = [
  ["path", { d: "M13 9V5.45377C13 4.65087 12.3491 4 11.5462 4C11.1941 4 10.8539 4.12781 10.5889 4.3597L3.75258 10.3415C3.27433 10.76 3 11.3645 3 12C3 12.6355 3.27433 13.24 3.75258 13.6585L10.5889 19.6403C10.8539 19.8722 11.1941 20 11.5462 20C12.3491 20 13 19.3491 13 18.5462V15H16C16.5523 15 17 14.5523 17 14V10C17 9.44772 16.5523 9 16 9H13Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 9L21 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowBigLeftDashIcon;
